<template>
  <rest-page :fetch-endpoint="fetchEndpoint" layout="tabbed">
    <template v-if="model">
      <page-header-new :breadcrumbs="breadcrumbs" :title="model.title" />
      <page-tabs :tabs="tabs"></page-tabs>
    </template>
  </rest-page>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import RestPage from '@/common/components/rest/RestPage'
import PageTabs from '@/common/components/page/PageTabs'

export default {
  name: 'SharedSegmentPage',

  components: {
    RestPage,
    PageTabs,
    PageHeaderNew
  },

  data() {
    return {
      model: null
    }
  },

  computed: {
    sharedSegmentId() {
      return this.$route.query.id
    },

    fetchEndpoint() {
      if (this.sharedSegmentId) {
        return projectEndpoint({
          method: 'get',
          url: `shared-segments/${this.sharedSegmentId}`,
          handler: data => {
            this.model = data
          }
        })
      } else {
        return null
      }
    },

    breadcrumbs() {
      return [
        {
          label: 'Data'
        },
        {
          label: this.$t('Audiences_Breadcrumb_Audiences'),
          route: projectRoute({
            name: 'AudienceSegmentSharedList'
          })
        },
        {
          label: this.$t('Audiences_Breadcrumb_SharedSegment')
        }
      ]
    },

    tabs() {
      return [
        {
          title: this.$t('Audiences_SegmentEvaluationsTab'),
          route: projectRoute({
            name: 'AudienceSharedSegmentEvaluations',
            query: {
              id: this.$route.query.id
            }
          })
        }
      ]
    }
  },

  mounted() {
    this.$router.push(
      projectRoute({
        name: 'AudienceSharedSegmentEvaluations',
        query: {
          id: this.$route.query.id
        }
      })
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/SharedSegmentPage.vue